module.exports = __webpack_public_path__ + "static/media/icon-html-file.08120d81.svg";